/* eslint-disable no-console */
import { Moment } from 'moment';
import { useMutation } from 'react-query';
import { API_URL } from '../constants';
import { participationTypeLabel } from '../participationLabels';

interface MutationResponse {
    success: boolean;
    message: string;
}

export interface RegisterValues {
    firstName: string;
    lastName: string;
    email: string;
    birthdate: Moment | null | undefined;
    city: string;
    country: string;
    grade: string;
    sensei_name: string;
    sayonaraParty?: number;
    tshirtSize?: string;
    tshirtQuantity?: number;
    danGrading: boolean;
    participationType: string;
    /** `'yes'` = TOGKF member, `'no'` = not a member (federation name required) */
    togkfMember: 'yes' | 'no' | '';
    federationName: string;
    totalPrice: number;
}

const useRegister = (
    // eslint-disable-next-line no-unused-vars
    onRegistrationComplete: (success: boolean, message: string) => void,
) =>
    useMutation<MutationResponse, Error, RegisterValues>(
        (values: RegisterValues) => {
            const { togkfMember, federationName, ...rest } = values;
            const resolvedFederation =
                togkfMember === 'yes'
                    ? 'TOGKF'
                    : String(federationName || '').trim();
            return fetch(API_URL, {
                method: 'POST',
                headers: {
                    'Content-Type': 'text/plain;charset=utf-8',
                },
                body: JSON.stringify({
                    ...rest,
                    participationType: participationTypeLabel(
                        values.participationType,
                    ),
                    federationName: resolvedFederation,
                }),
            }).then(response => {
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                return response.json();
            });
        },
        {
            onSuccess: (data: {
                statusCode?: number;
                message?: string;
                result?: string;
                data?: { message?: string };
            }) => {
                const ok = data.statusCode === 201 || data.result === 'success';
                const message =
                    data.message ??
                    data.data?.message ??
                    (ok ? 'Registration successful' : 'Registration failed');
                if (ok) {
                    onRegistrationComplete(true, message);
                } else {
                    onRegistrationComplete(false, message);
                }
            },
            onError: error => {
                console.error('Submission error:', error);
            },
        },
    );

export default useRegister;
